// import {
//   Card,
//   Typography,
//   CardContent,
//   Box,
//   Avatar,
//   Button,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
// import ScheduleIcon from "@mui/icons-material/Schedule";
// import { palette, theme as colorTheme } from "../../../Convoze.theme";

// function AgentCard({ agent }) {
//   const navigate = useNavigate();

//   const primary = colorTheme('palette', 'primary').value
//   const secondary = colorTheme('palette', 'secondary').value
//   const positive = colorTheme('palette', 'positive').value


//   return (
//     <Card
//       sx={{
//         // width: 1,
//         // maxWidth: { xs: 160, sm: 180, md: 200, lg: 220 },
//         // height: { xs: 220, sm: 235, md: 250 },
//         borderRadius: 4,
//         boxShadow: 3,
//         p: { xs: 1, sm: 1.5 },
//         display: "flex",
//         flexDirection: "column",
//         background: "#fff",
//         border: "1px solid #e5e7eb",
//         cursor: "pointer",
//         transition: "all .3s ease",
//         "&:hover": {
//           transform: "translateY(-2px)",
//           boxShadow: 6,
//         },
//       }}

//       onClick={() =>
//         navigate(
//           `/user/agent-profile/${agent?.agentId}?avatar=${encodeURIComponent(
//             agent?.avatarUrl
//           )}&agentName=${encodeURIComponent(agent?.agentName)}`
//         )
//       }
//     >
//       <CardContent
//         sx={{
//           flexGrow: 1,
//           px: 1,
//           py: 2,
//           display: "flex",
//           flexDirection: "column",
//           gap: 0.4,
//         }}
//       >
//         {/* Avatar + Name + Status */}
//         <Box display="flex" alignItems="center" gap={1.2} mb={1}>
//           <Avatar
//             src={agent?.avatarUrl}
//             // src={agent?.avatarUrl()}
//             sx={{
//               width: { xs: 40, sm: 44, md: 48 },
//               height: { xs: 40, sm: 44, md: 48 },
//               // bgcolor: "#6366F1",
//               bgcolor : primary,
//               p: 0.3,
//               borderRadius: "50%",
//               "& img": {
//                 objectFit: "contain",
//                 borderRadius: "50%",
//               },
//             }}
//           />

//           <Box>
//             <Typography
//               variant="h6"
//               fontWeight={700}
//               lineHeight={1}
//               color="text.primary"
//               sx={{ fontSize: { xs: "0.8rem", sm: "0.9rem", md: "0.95rem" } }}
//             >
//               {agent?.agentName}
//             </Typography>

//             <Box display="flex" alignItems="center" gap={2} mt={0.2}>
//               <Typography
//                 sx={{
//                   // backgroundColor: "#10b981",
//                   backgroundColor : positive,
//                   color: "white",
//                   px: 1.5,
//                   borderRadius: "10px",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   fontSize: { xs: "0.7rem", sm: "0.75rem", md: "0.8rem" },
//                   gap: 0.5,
//                 }}
//                 variant="caption"
//                 fontWeight={600}
//               >
//                 <Box
//                   sx={{
//                     width: 3,
//                     height: 3,
//                     borderRadius: "50%",
//                     bgcolor: "white",
//                   }}
//                 />
//                 Active
//               </Typography>
//             </Box>
//           </Box>
//         </Box>

//         {/* Role */}
//         <Typography
//           variant="caption"
//           fontWeight={600}
//           sx={{ fontSize: { xs: "0.65rem", sm: "0.7rem" }, mb: 0.2 }}
//         >
//           Customer Support Executive
//         </Typography>

//         {/* ID */}
//         <Typography
//           variant="caption"
//           fontWeight={600}
//           sx={{ mb: 1, fontSize: { xs: "0.7rem", sm: "0.75rem" } }}
//         >
//           ID: {agent?.agentId}
//         </Typography>

//         <Box sx={{ borderBottom: "1px solid #e5e7eb", my: 1 }} />

//         {/* Rank & Calls row */}
//         {/* <Box
//           display="flex"
//           justifyContent="space-between"
//           alignItems="center"
//           mb={0.4}
//         >
//           <Typography
//             variant="body2"
//             fontWeight={700}
//             sx={{ fontSize: { xs: "0.7rem", sm: "0.75rem" } }}
//           >
//             Rank: {agent.rank}
//           </Typography>

//           <Box sx={{ px: 0.8, py: 0.2, borderRadius: 1, bgcolor: "#e5e7eb" }}>
//             <Typography
//               variant="body2"
//               fontWeight={700}
//               sx={{
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 0.5,
//                 fontSize: { xs: "0.6rem", sm: "0.65rem" },
//               }}
//             >
//               <HeadsetMicIcon sx={{ fontSize: { xs: 10, sm: 12 } }} /> 142 calls
//             </Typography>
//           </Box>
//         </Box> */}

//         {/* Shift */}
//         <Typography
//           variant="caption"
//           fontWeight={600}
//           // color="#6b7280"
//           color={secondary}

//           mb={1}
//           sx={{
//             display: "inline-flex",
//             alignItems: "center",
//             gap: 0.5,
//             fontSize: { xs: "0.7rem", sm: "0.75rem" },
//           }}
//         >
//           <ScheduleIcon sx={{ fontSize: { xs: 12, sm: 14 } }} />
//           Shift: {agent?.shift || "9am to 6pm"}
//         </Typography>

//         {/* View Performance - bottom */}
//         <Box mt="auto" pt={1}>
//           <Button
//             variant="contained"
//             size="small"
//             disableElevation
//             fullWidth
//             sx={{
//               color: "#fff",
//               px: 2,
//               py: 0.6,
//               borderRadius: 3,
//               textTransform: "none",
//               fontSize: { xs: "0.65rem", sm: "0.7rem" },
//               // background: "linear-gradient(90deg, #6366F1, #8B5CF6)",
//               background : primary,
//               "&:hover": {
//                 // background: "linear-gradient(90deg, #4F46E5, #7C3AED)",
//                 background : primary
//               },
//             }}
//           >
//             View Performance
//           </Button>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// }

// export default AgentCard;








import {
  Card,
  CardContent,
  Avatar,
  Typography,
  Chip,
  Button,
  Box,
  Badge,
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';
import { theme as colorTheme } from '../../../Convoze.theme';
import ProfileImg from "../../../assets/ProfileImg.png";

export default function AgentCard({ agent }) {
  const navigate = useNavigate();
  const primary = colorTheme('palette', 'primary').value;
  const positive = colorTheme('palette', 'positive').value;
  const positiveBg = colorTheme('palette', 'positiveBg').value;

 return (
  <Card
    onClick={() =>
      navigate(
        `/user/agent-profile/${agent?.agentId}?avatar=${encodeURIComponent(
          agent?.avatarUrl
        )}&agentName=${encodeURIComponent(agent?.agentName)}`
      )
    }
    sx={{
      borderRadius: 5,
      border: '1px solid #e0e0e0',
      backgroundColor: '#fff',
      cursor: 'pointer',
      transition: '0.3s',
      '&:hover': { boxShadow: '0 4px 16px rgba(0,0,0,0.08)' },
      display: 'flex',
      flexDirection: 'column',
      gap: 2, 
      p: 1.5
    }}
  >
    {/* ---------- TOP section  ---------- */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}
    >
      <Badge
        badgeContent={agent?.rank}
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        sx={{
          '& .MuiBadge-badge': {
            fontSize: 10,
            height: 18,
            minWidth: 18,
            border: '2px solid #fff',
            bgcolor: primary,
            color: '#fff',
          },
        }}
      >
        <Avatar
          src={ProfileImg}
          sx={{
            width: { xs: 40, sm: 46, md: 50 },
            height: { xs: 40, sm: 46, md: 50 },
            '& img': { objectFit: 'contain' },
          }}
        />
      </Badge>

      <Box display="flex" flexDirection="column" >
        <Typography fontSize={14} fontWeight={600} lineHeight={1.2}>
          {agent?.agentName}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {agent?.role}
        </Typography>
      </Box>
    </Box>

    {/* ---------- (Shift + Status) ---------- */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent:"space-between",
        px:1
      }}
    >
      <Box display="flex" alignItems="center" gap={0.8}>
        <AccessTimeIcon sx={{ fontSize: 16, color: '#000000b6' }} />
        <Typography variant="body2" color="#000000b6">
          {agent?.shift}
        </Typography>
      </Box>

      <Chip
        label={agent?.status === 'Active' ? 'Active' : 'Inactive'}
        size="small"
        sx={{
          borderRadius: 50,
          fontSize: 12,
          fontWeight: 500,
          backgroundColor:
            agent?.status === 'Active' ? positiveBg : '#0000000a',
          color: agent?.status === 'Active' ? '#0e4818ff' : '#000000b6',
        }}
      />
    </Box>

    {/* ----------  (Button) ---------- */}
    <Box >
      <Button
        onClick={(e) => {
          e.stopPropagation();
          navigate(
            `/user/agent-profile/${agent?.agentId}?avatar=${encodeURIComponent(
              agent?.avatarUrl
            )}&agentName=${encodeURIComponent(agent?.agentName)}`
          );
        }}
        variant="text"
        endIcon={<ArrowForwardIcon />}
        sx={{
          justifyContent: 'space-between',
          color: primary,
          fontWeight: 500,
          textTransform: 'none',
          width: '100%',
        }}
      >
        View Performance
      </Button>
    </Box>
  </Card>
);
}
